
import kinematicConfiguratorGetters from "./KinematicConfiguratorGetters";
import kinematicParametersMutations from "./KinematicConfiguratorMutations";
import kinematicParametersActions from "./KinematicConfiguratorActions";
import {
	TurbineShaftsFactory, TurbineVersionFactory,
	GearsFactory,
	TurbinePropertiesFactory,
	GearboxStagesFactory,
	GearsMeshFrequenciesFactory,
	GearboxFactory
} from "../factories/KinematicParametersFactory";
import ToastMessageType from "@/constants/enums/ToastMessageType";

const state = {
	turbineProperties:                TurbinePropertiesFactory(),
	turbinePropertiesValid:           false,
	gearboxPropertiesValid:           false,
	shaftPropertiesValid:             false,
	shaftBearingPropertiesValid:      false,
	gearsPropertiesValid:             false,
	gearMeshFrequencyPropertiesValid: false,
	effectiveSincePropertiesValid:    false,
	turbineVersionsModel:             TurbineVersionFactory(),
	shafts:                           [ TurbineShaftsFactory() ],
	gearbox:                          GearboxFactory(),
	gearboxStages:                    [ GearboxStagesFactory() ],
	gearsMeshFrequencies:             [ GearsMeshFrequenciesFactory() ],
	gears:                            [ GearsFactory() ],
	toast:                            {
		show:    false,
		message: "",
		type:    ToastMessageType.ERROR
	},
	isFormDisabled: false,
};

const { mutations } = kinematicParametersMutations;

const { actions } = kinematicParametersActions;

const { getters } = kinematicConfiguratorGetters;

export default {
	state,
	mutations,
	actions,
	getters,
	namespace: true
};